<!-- 主页面 -->
<template>
  <div class="layout_box">
    <top-nav class="topNav" />
    <div style="height: 65px"></div>
    <keep-alive>
    <router-view/>
    </keep-alive>
  </div>
</template>
<script >
import TopNav from "./components/topNav.vue";

export default {
  data() {
    return {};
  },
  components: { TopNav },
  created() {},
  methods: {
  },
};
</script>
<style lang='less'>
.layout_box {
  width: 100%;
  &::before {
    content: "";
  }
  .topNav {
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 999;
  }
}
</style>